type State = {
  id: string | undefined;
  gotError: boolean;
};

export const state: State = {
  id: undefined,
  gotError: false
};
